<template>
  <v-container class="cmp-booking-booking-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <BookingDetails
        :booking="booking"
        :lock-json="lockJson"
        @updated="onBookingCdateUpdated"
      />
      <glayout
        :tabs="bookingSidewindowTabs"
        :shareOptions="[
          {
            text: $t('new_questionnaire'),
            value: 'new_questionnaire',
          },
          {
            text: $t('new_questionnaire_in_web'),
            value: 'new_questionnaire_in_web',
          },
          {
            text: $t('questionnaire_lock_status'),
            value: 'questionnaire_lock_status',
          },
          {
            text: $t('copy_link'),
            value: 'copy-link',
          },
        ]"
        :menu="[
          {
            text: $t('dl_booking_ics'),
            value: 'download-ics',
          },
          {
            text: $t('delete'),
            value: 'delete',
            error: true,
          },
        ]"
        :loading="!booking.external_table"
        @optionClicked="onTabOptionClicked"
      >
        <!-- <template #tabPanelRight>
          <div class="tabs-options--panel" style="display: flex">
            <div class="dt-icon-container">
              <img
                src="static/icons/ai/details_ai.png"
                class="dt-icon v5"
                style="height: 35px; width: auto; margin: 3px 6px"
                alt
                @click.stop="(e) => onClickAIRobot()"
              />
            </div>
          </div>
        </template> -->
        <gtab>
          <grow>
            <gcol>
              <gbox
                :loading="booking.overview_loading"
                :title="$t('artists')"
                :h="
                  boxHeight(
                    booking && booking.artists && booking.artists.length
                  )
                "
              >
                <Artists
                  :booking="booking"
                  @artist_calendar_date_selected="onArtistCalendarDateSelected"
                  @updated="onArtistUpdated"
                  @deleted="onArtistsDelete"
                  @reload="onReloadArtists"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :loading="booking.overview_loading"
                :title="$t('checklist')"
              >
                <Checklist
                  :booking="booking"
                  :lockJson="lockJson"
                  :local_details_confirmed_flag="local_details_confirmed_flag"
                  @updated="onBookingCdateUpdated"
                  @tdf_updated="onBookingTravelDetailsFlagUpdated"
                  @local_details_confirmed_flag_changed="
                    onLocalDetailsConfirmedFlagChange
                  "
                  @no_travel_needed_flag_changed="onNoTravelNeededFlagChange"
                />
              </gbox>
              <gbox
                :loading="booking.overview_loading"
                :title="$t('notes_for_rider')"
              >
                <DBox id="booking-booking-notes_for_rider" :addButton="false">
                  <DBoxTextarea
                    :value="booking.cdate.notes"
                    :id="'notes'"
                    :yellowStyle="false"
                    @blur="
                      (e) =>
                        onDBoxTextAreaBlur({
                          name: 'notes',
                          value: e.target.value,
                        })
                    "
                  />
                </DBox>
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :loading="booking.overview_loading"
                :title="$t('custom_checklist')"
                :h="
                  boxHeight(
                    booking &&
                      booking.custom_checklist &&
                      booking.custom_checklist.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <CustomChecklist
                  :booking="booking"
                  @inserted="onCustomChecklistInserted"
                  @updated="onCustomChecklistUpdated"
                  @checked="onCustomchecklistChecked"
                  @unchecked="onCustomChecklistUnchecked"
                  @deleted="onCustomChecklistDeleted"
                />
              </gbox>
              <gbox
                :loading="booking.overview_loading"
                :title="$t('deal_memo_internal')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :id="'first_offer_notes'"
                  :value="booking.cdate.first_offer_notes"
                  @blur="
                    (e) =>
                      onDBoxTextAreaBlur({
                        name: 'first_offer_notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tasks">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: dBoxBalancesRowCount,
                    offset:
                      booking &&
                      booking.task_list &&
                      booking.task_list.length > 0
                        ? balancesSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52
                          : NTOffsets.WithHeaderDBoxBottom
                        : balancesSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52
                        : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
                :title="$t('task_list')"
              >
                <TaskList
                  :booking="booking"
                  @showSearchFlag="onBalancesSearchClick"
                  @menu="onClickTaskListMenu"
                  @changed="onTaskListItemChanged"
                  @delete="onTaskListItemDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="money_details">
          <grow>
            <gcol>
              <gbox :title="$t('invoicing')">
                <Invoicing
                  :booking="booking"
                  :selectedInvoiceLines="selectedInvoiceLines"
                  @deleted="onInvoicingInvoiceLineDeleted"
                  @inserted="onInvoicingInvoiceLineInsert"
                  @selected="onInvoicingInvoiceLinesSelected"
                  @updated="onInvoicingUpdated"
                  @menu_click="onCreateInvoiceCreate"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="documents" :title="$t('btn_documents')">
          <template #header>
            <grow>
              <gcol>
                <div style="margin-top: 5px">
                  <button
                    style="margin-left: 0px; text-transform: uppercase"
                    class="dt-button v5 s8"
                    @click="onSendDocumentAndFilesClick"
                  >
                    {{ $t("send_document_and_files") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      booking && booking.documents && booking.documents.length,
                    offset:
                      booking.documents.length > 0
                        ? NTOffsets.WithHeader
                        : NTOffsets.WithHeaderDBoxBottom + 32,
                  })
                "
                :title="$t('document')"
              >
                <DocumentTable
                  :booking="booking"
                  @deleted="onDocumentDeleted"
                  @signed="onDocumentSigned"
                  @sendmail="onDocumentSendMail"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('templates')"
                :h="
                  boxHeight(
                    booking && booking.templates && booking.templates.length,
                    NTOffsets.WithHeader
                  )
                "
              >
                <TemplateSelection
                  :booking="booking"
                  @fetch="onTemplateSelectionFetch"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('tab_title_files')"
                :h="
                  boxHeight(
                    booking && booking.files && booking.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <DBoxFiles
                  :files="booking.files"
                  :externalId="calendar_date_id"
                  :externalTable="'calendar_dates'"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="event_details">
          <grow>
            <gcol>
              <gbox
                :title="$t('event_details_artists')"
                :h="
                  boxHeight(
                    booking && booking.artists && booking.artists.length,
                    NTOffsets.WithHeader
                  )
                "
              >
                <EventDetailsArtists
                  :booking="booking"
                  :lockJson="lockJson"
                  @artist_calendar_date_selected="onArtistCalendarDateSelected"
                  @updated="onArtistUpdated"
                  @invoice_text_updated="onEventDetailsInvoiceTextUpdated"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :title="$t('timetable_lineup')">
                <DBox id="booking-booking-timetable_lineup" :addButton="false">
                  <DBoxTextarea
                    :value="booking.cdate.lineup"
                    :id="'lineup'"
                    :yellowStyle="false"
                    @blur="
                      (e) =>
                        onDBoxTextAreaBlur({
                          name: 'lineup',
                          value: e.target.value,
                        })
                    "
                  />
                </DBox>
              </gbox>
              <gbox
                :title="$t('location_info')"
                :h="
                  boxHeight(
                    booking &&
                      booking.custom_fields_venue_data &&
                      booking.custom_fields_venue_data.length,
                    NTOffsets.default + 1
                  )
                "
              >
                <CustomFields
                  v-if="booking && booking.custom_fields_venue_data"
                  :fields="booking.custom_fields_venue_data"
                  :section="'bsettings'"
                  :externalId="calendar_date_id"
                  :externalTable="'booking_locations'"
                  :hint="venueCustomFieldHint"
                  :disabled="true"
                  @changed="onBookingVenueInfoChange"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('event_details')">
                <EventDetails
                  :booking="booking"
                  @update="onBookingCdateUpdated"
                />
              </gbox>
              <gbox :title="$t('further_event_details')">
                <FurtherEventDetails
                  :booking="booking"
                  :hint="eventCustomFieldHint"
                  @update="onFurtherEventDetailsUpdate"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="travel_details">
          <grow>
            <gcol>
              <gbox :title="$t('travel_party')">
                <TDContactRelations
                  :booking="booking"
                  @insert_relation="onTDContactRelationsInsert"
                  @insert_contact="onTDContactRelationInsertContact"
                  @deleted="onTDContactRelationsDelete"
                  @get_contacts_button="onGetContactsClick"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('travel_before')"
                :h="
                  (booking &&
                    booking.before_travels &&
                    booking.before_travels.length) > 0
                    ? boxHeight(
                        booking.before_travels.length,
                        NTOffsets.withHeaderDBoxBottom,
                        122
                      )
                    : boxHeightNamed({
                        rowCount:
                          booking &&
                          booking.preview_load_travelBefore &&
                          booking.preview_load_travelBefore.length,
                        offset:
                          booking.preview_load_travelBefore.length > 0
                            ? NTOffsets.WithDBoxBottom + 92
                            : NTOffsets.WithDBoxBottom,
                        min: 0,
                      })
                "
              >
                <TravelBefore
                  :travels="booking.before_travels"
                  :booking="booking"
                  :travelListHeaders="travelListHeaders"
                  @inserted="onTravelInserted"
                  @edited="onTravelEdited"
                  @updated="onTravelUpdated"
                  @deleted="onTravelDeleted"
                  @load_travel_from="onLoad_travel_from"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('travel_after')"
                :h="
                  (booking &&
                    booking.after_travels &&
                    booking.after_travels.length) > 0
                    ? boxHeight(
                        booking.after_travels.length,
                        NTOffsets.withHeaderDBoxBottom,
                        122
                      )
                    : boxHeightNamed({
                        rowCount:
                          booking &&
                          booking.preview_load_travelAfter &&
                          booking.preview_load_travelAfter.length,
                        offset:
                          booking.preview_load_travelAfter.length > 0
                            ? NTOffsets.WithDBoxBottom + 92
                            : NTOffsets.WithDBoxBottom,
                        min: 0,
                      })
                "
              >
                <TravelAfter
                  :booking="booking"
                  :travels="booking.after_travels"
                  :travelListHeaders="travelListHeaders"
                  @inserted="onTravelInserted"
                  @edited="onTravelEdited"
                  @updated="onTravelUpdated"
                  @deleted="onTravelDeleted"
                  @load_travel_from="onLoad_travel_from"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="local_details">
          <grow>
            <gcol>
              <gbox
                :title="$t('relation')"
                :h="
                  booking &&
                  booking.calendar_date_locals &&
                  booking.calendar_date_locals.length > 0
                    ? boxHeight(
                        booking.calendar_date_locals.length,
                        NTOffsets.withHeaderDBoxBottom
                      )
                    : 128
                "
              >
                <Relation
                  :booking="booking"
                  :lockJson="lockJson"
                  :local_details_confirmed_flag="local_details_confirmed_flag"
                  @deleted="onRelationDeleted"
                  @added="onRelationAdded"
                  @saved="onRelationSaved"
                  @save_promoter="onRelationsSavePromoter"
                  @lockQuestion="updateQuestionnaireLockJSON"
                  @local_details_confirmed_flag_changed="
                    onLocalDetailsConfirmedFlagChange
                  "
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :title="$t('local_info')">
                <DBoxTextarea
                  :style="{ backgroundColor: 'white' }"
                  :value="booking.cdate.local_info"
                  :id="'local_info'"
                  @blur="onLocalDetailsInfoBlur"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <template v-if="artistCalendarDateModalContainer">
      <v-dialog persistent v-model="artistCalendarDateModal" width="800">
        <ArtistCalendarDate
          :artistCalendarDateProp="{
            calendarDateId: booking.cdate.calendar_date_id,
            calendarDateArtistId: $route.query.calendar_date_artist_id,
          }"
          @done="onArtistCalendarDone"
          @cancelled="onArtistCalendarDateModalCancel"
        />
      </v-dialog>
    </template>

    <template v-if="addArtistModalContainer && booking && booking.cdate">
      <v-dialog persistent v-model="addArtistModal" width="390">
        <AddArtist
          :booking="booking"
          @done="addArtistModalDone"
          @cancelled="addArtistModalCancelled"
        />
      </v-dialog>
    </template>
    <template v-if="addTaskModalContainer && calendar_date_id">
      <v-dialog persistent v-model="addTaskModal" width="800">
        <AddTask
          :booking="booking"
          :calendar_date_id="calendar_date_id"
          @done="onAddTaskDone"
          @doneAI="onAITaskAssignDone"
          @cancelled="addTaskModalCancelled"
        />
      </v-dialog>
    </template>
    <template v-if="addInvoiceLineModalConainer && calendar_date_id">
      <v-dialog persistent v-model="addInvoiceLineModal" width="390">
        <AddInvoiceLine
          :calendarDateId="calendar_date_id"
          @done="doneAddInvoiceLine"
          @cancelled="addInvoiceLineModalCancelled"
        />
      </v-dialog>
    </template>

    <template v-if="createInvoiceModalConainer && calendar_date_id > 0">
      <v-dialog persistent v-model="createInvoiceModal" width="390">
        <SelectInvoiceProject
          v-if="selectedInvoiceLines.size > 0"
          :invoiceProjects="invoiceProjects"
          :loading="invoiceProjectLoading"
          :loadingText="invoiceProjectLoadingText"
          @selected="onInvoiceProjectSelected"
          @cancelled="onModalCancelled"
        />
      </v-dialog>
    </template>

    <ModalContainer
      :modalKey="'questionnaire'"
      :width="'small3'"
      @cancelled="onModalCancelled"
    >
      <Questionnaire 
        :booking="booking" 
        @cancelled="onModalCancelled" 
        @onLoadLocalDetails="onLoadLocalDetails"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'questionnaire_lock_status'"
      :width="'medium'"
      @cancelled="onModalCancelled"
    >
      <QuestionnaireLockStatus
        :booking="booking"
        @cancelled="onModalCancelled"
        @changed="updateQuestionnaireLockJSON"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'offerMail'"
      :width="'small'"
      @cancelled="onModalCancelled"
    >
      <OfferMail :booking="booking" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'taskListLoadTasks'"
      :width="'small'"
      @cancelled="onModalCancelled"
    >
      <TaskListLoadTasks
        :booking="booking"
        @submitted="loadTaskList"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer
      :modalKey="'taskListAddTask'"
      :width="'small'"
      @cancelled="onModalCancelled"
    >
      <TaskListAddTask
        :booking="booking"
        @submitted="addTaskListItem"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { groupBy } from "lodash";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";

import BookingDetails from "./booking-details";

import DBoxFiles from "./../../../../dt-plugins/dbox-files/dbox-files";
import CustomFields from "@/dt-plugins/custom-fields/custom-fields";

import EventDetailsArtists from "./event-details-artists";
import FurtherEventDetails from "./further-event-details.vue";
import EventDetails from "./event-details";
import LineUp from "./line-up";

import TemplateSelection from "./template-selection";
import DocumentTable from "./document-table";

import Relation from "./relation";

import ArtistCalendarDate from "./artist-calendar-date";
import AddArtist from "./add-artist";
import AddTask from "./add-task";

import Invoicing from "./invoicing";
import AddInvoiceLine from "./add-invoice-line";
import CreateInvoice from "./create-invoice";

import Artists from "./artists";
import Checklist from "./checklist";
import CustomChecklist from "./custom-checklist";
import Tasks from "./tasks";
import Deal from "./deal";
import Notes from "./notes";

import TravelBefore from "./travel-before";
import TravelAfter from "./travel-after";
import TDContactRelations from "./td-contact-relations";

import Questionnaire from "./questionnaire";
import QuestionnaireLockStatus from "./questionnaire-lock-status";
import OfferMail from "./offer-mail";
import QuestionarieMail from "./questionarie-mail";

import TaskList from "./task-list";
import TaskListLoadTasks from "./task-list-load-tasks";
import TaskListAddTask from "./task-list-add-task";

import { bookingListCalendarDateTabRoute } from "../../router/router";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";

import { copyToClipboard } from "../../../../dt-plugins/clipboard/clipboard";
import { waitForAnimation, encodeRoute, wait, sendMailHref } from "../../../../utility";
import {
  NotificationService,
  showError,
  showNotification,
} from "../../../../dt-plugins/notification/notification.service";
import { isCalendarDateIdValid } from "../../models/booking-overview.model";

import { checkTabListPermission } from "../../../../router/guard";
import {
  openModalRoute,
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { overviewService } from "../../services/booking-details/booking-overview.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { bookingsActions } from "../../store/bookings/actions";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { bookingsGetters } from "../../store/bookings/getters";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createTaxTypeTV } from "../../../../models/tax.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader } from "../../../../plugins/datatable";
import { MHTTPCL, clientName } from "../../../../services/http/http-client";
import {
  filterTravelAfter,
  filterTravelBefore,
} from "../../models/travel.model";

import SelectInvoiceProject from "../../../../dt-plugins/select-invoice-project/select-invoice-project-modal";
import { BookingService } from "../../services/booking-service";

const moduleRoute = "booking";
const submenuRoute = "calendar";

export default {
  components: {
    CustomFields,
    BookingDetails,
    Artists,
    Checklist,
    CustomChecklist,
    Tasks,
    Deal,
    Notes,
    Invoicing,
    TemplateSelection,
    DocumentTable,
    DBoxFiles,
    EventDetailsArtists,
    FurtherEventDetails,
    LineUp,
    EventDetails,
    TravelBefore,
    TravelAfter,
    TDContactRelations,
    Relation,
    ArtistCalendarDate,
    AddArtist,
    AddTask,
    AddInvoiceLine,
    CreateInvoice,
    DBoxTextarea,
    ModalContainer,
    Questionnaire,
    QuestionnaireLockStatus,
    OfferMail,
    QuestionarieMail,

    SelectInvoiceProject,

    TaskList,
    TaskListLoadTasks,
    TaskListAddTask,
  },
  data: function () {
    return {
      active: 0,
      e1: undefined,
      selected: null,
      isMobile: false,

      artistCalendarDateModalContainer: false,
      artistCalendarDateModal: false,
      artistCalendarDateProp: null,
      addArtistModalContainer: false,
      addArtistModal: false,

      addTaskModal: false,
      addTaskModalContainer: false,

      addInvoiceLineModal: false,
      addInvoiceLineModalConainer: false,

      createInvoiceModal: false,
      createInvoiceModalConainer: false,

      // Selected Invoices
      selectedInvoiceLines: new Set(),

      // Create Invoice Data
      invoiceProjects: [],
      invoiceProjectLoading: true,
      invoiceProjectLoadingText: "Loading ...",

      balancesSearchFlag: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("questionarieMail"),
    createModalMixin("questionnaire"),
    createModalMixin("questionnaire_lock_status"),
    createModalMixin("offerMail"),
    createModalMixin("taskListLoadTasks"),
    createModalMixin("taskListAddTask"),
  ],
  mounted: async function () {
    this.routeMount();
    // window.onresize = this.windowResizeHandler;
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        if (to && to.query.calendar_date_artist_id) {
          this.artistCalendarDateProp = {
            calendarDateId: to.params.calendar_date_id,
            calendarDateArtistId: to.query.calendar_date_artist_id,
          };

          this.artistCalendarDateModalContainer = true;
          setTimeout(() => {
            this.artistCalendarDateModal = true;
          }, 1);
        } else if (from && from.query.calendar_date_artist_id) {
          this.artistCalendarDateModal = false;
          waitForAnimation(() => {
            this.artistCalendarDateModalContainer = false;
          });
        }

        if (to && to.query.modal === "add_artist_to_booking") {
          this.addArtistModalContainer = true;
          setTimeout(() => {
            this.addArtistModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "add_artist_to_booking" &&
          to.query.modal !== "add_artist_to_booking"
        ) {
          this.addArtistModal = false;
          waitForAnimation(() => {
            this.addArtistModalContainer = false;
          });
        }

        if (to && to.query.modal === "add_task") {
          this.addTaskModalContainer = true;
          setTimeout(() => {
            this.addTaskModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "add_task" &&
          to.query.modal !== "add_task"
        ) {
          this.addTaskModal = false;
          waitForAnimation(() => {
            this.addTaskModalContainer = false;
          });
        }

        if (to && to.query.modal === "add_invoice_line") {
          this.addInvoiceLineModalConainer = true;
          setTimeout(() => {
            this.addInvoiceLineModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "add_invoice_line" &&
          to.query.modal !== "add_invoice_line"
        ) {
          this.addInvoiceLineModal = false;
          waitForAnimation(() => {
            this.addInvoiceLineModalConainer = false;
          });
        }

        if (to && to.query.modal === "create_invoice") {
          this.createInvoiceModalConainer = true;
          setTimeout(() => {
            this.createInvoiceModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "create_invoice" &&
          to.query.modal !== "create_invoice"
        ) {
          this.createInvoiceModal = false;
          waitForAnimation(() => {
            this.createInvoiceModalConainer = false;
          });
        }
      },
    },
  },
  computed: {
    ...mapGetterObject(storeNS, bookingsGetters),

    bookingSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_overview"),
          vgi_id: "artists",
        },
        {
          route: "tasks",
          value: this.$t("tab_title_tasks"),
          vgi_id: "tasks",
        },
        {
          route: "money_details",
          value: this.$t("tab_title_new_deals"),
          vgi_id: "money_details_section",
        },
        {
          route: "documents",
          value: this.$t("tab_title_documents"),
          vgi_id: "documents_section",
        },
        {
          route: "event_details",
          value: this.$t("tab_title_artist_details"),
          vgi_id: "event_details_section",
        },
        {
          route: "travel_details",
          value: this.$t("tab_title_travel_details"),
          vgi_id: "travel_details_section",
        },
        {
          route: "local_details",
          value: this.$t("tab_title_local_details"),
          vgi_id: "local_details_section",
        },
      ]);
    },
    venueCustomFieldHint() {
      return `
      ${this.$t(
        "custom-venue-fields-can-be-added-in"
      )} <a href="./#/main/settings/booking/request_settings">${this.$t(
        "menu_Settings"
      )} -> ${this.$t("booking")} -> ${this.$t(
        "tab_title_request_settings"
      )} -> ${this.$t("venue")}</a>
      `;
    },
    eventCustomFieldHint() {
      return `
      ${this.$t(
        "custom-event-fields-can-be-added-in"
      )} <a href="./#/main/settings/booking/request_settings">${this.$t(
        "menu_Settings"
      )} -> ${this.$t("booking")} -> ${this.$t(
        "tab_title_request_settings"
      )} -> ${this.$t("event_l")}</a>
      `;
    },
    travelListHeaders: function () {
      return [
        createTableHeader("artist", { text: "Name" }),
        createTableHeader("itinerary", { text: "Itinerary", f: 3 }),
        createTableHeader("travel", { text: "Travel No." }),
        createTableHeader("filekey"),
        createTableHeader("costs", { text: "Costs", ta: "right" }),
        createTableHeader("confirmed", { mw: 84, ta: "center" }),
        createTableHeader("icon", { text: false, mw: 30 }),
        createTableHeader("close", { text: false, mw: 30 }),
      ];
    },
    calendar_date_id: function () {
      return this.$route.params.calendar_date_id;
    },
    calendarDateId: function () {
      return this.$route.params.calendar_date_id;
    },
    booking: function () {
      const booking = this.bookingDetails[this.calendar_date_id] || {};

      const cdate = booking.cdate || {};

      const travels = booking.travels || [];

      const before_travels = filterTravelBefore(travels, cdate) || [];
      const after_travels = filterTravelAfter(travels, cdate) || [];

      const preview_load_travelBefore =
        booking?.preview_load_travel?.travel_before || [];
      const preview_load_travelAfter =
        booking?.preview_load_travel?.travel_after || [];
      const custom_checklist = (booking?.custom_checklist || []).filter(
        (e) => e.name
      );

      // console.log('mdsir: task_list', booking.task_list);

      const obj = groupBy(booking?.task_list || [], "chapter_build");
      let task_list = [];
      if (Object.keys(obj).length > 0) {
        Object.keys(obj).forEach((value, index) => {
          let objectValues = Object.values(obj)[index];
          objectValues[0].new_group_title = 1;
          objectValues[0].group_title = objectValues[0].chapter_header;
          // objectValues = objectValues.map((obj) => {
          //   obj.disabled = value === "open_balances" ? false : true;
          //   return obj;
          // });
          task_list.push(...objectValues);
        });
      }

      const bookingDetails = {
        ...booking,
        cdate: booking.cdate || {},
        artists: booking.artists || [],
        statuses: booking.booking_status || [],
        statusesTV: (booking.statuses || []).map((e) => ({
          text: e.booking_status_name,
          value: e.booking_status_id,
          color: `#${e.booking_status_colour}`,
        })),
        currencies: booking.currencies || [],
        currenciesTV: createCurrencyTV(booking.currencies),
        custom_checklist,
        invoice_itemgroups: booking.invoice_itemgroups || [],
        calendar_date_id: this.calendar_date_id,
        tax_types: booking.tax_types || [],
        tax_typesTV: createTaxTypeTV(booking.tax_types),
        templates: booking.templates || [],
        documents: booking.documents || [],
        files: booking.files || [],
        contact_relations: booking.contact_relations || [],
        calendar_date_locals: booking.calendar_date_locals || [],
        relation_types: booking.relation_types || [],

        before_travels,
        after_travels,
        preview_load_travelBefore,
        preview_load_travelAfter,
        task_list,
      };
      // console.log("bookingDetails SelectedEntityDetails Updated", {
      //   calendar_date_id: this.calendar_date_id,
      //   bookingDetails: this.bookingDetails,
      //   booking,
      //   external_table: bookingDetails.external_table,
      // });
      return bookingDetails;
    },
    cdate: function () {
      return this.booking?.cdate || {};
    },
    lockJson: function () {
      return this.cdate?.lock_json ? JSON.parse(this.cdate.lock_json) : {};
    },
    isEventDetailsLocked() {
      return (
        this.booking.artists.filter(
          (artist) =>
            this.lockJson[
              `calendar_date_artists_${artist.calendar_date_artist_id}`
            ] === "lock"
        ).length === this.booking.artists.length
      );
    },
    local_details_confirmed_flag: function () {
      const cdlLenght = this.booking.calendar_date_locals.length;
      if (cdlLenght < 1) {
        return false;
      }

      return (
        this.booking.calendar_date_locals.filter(
          (row) =>
            this.lockJson[`local_details_${row.local_detail_id}`] === "lock"
        ).length == cdlLenght
      );
    },
    dBoxBalancesRowCount: function () {
      const totalCount = this.booking.task_list.reduce((acc, curr) => {
        if (curr.new_group_title == 1 || curr.new_group_title == "1") {
          acc += 2;
        } else {
          acc += 1;
        }
        return acc;
      }, 0);
      return this.booking?.task_list?.length > 0 ? totalCount : 0;
    },
  },
  methods: {
    ...mapActionObject(storeNS, bookingsActions),
    routeMount: function () {},
    closeBookingDetails: function (e) {
      this.$emit("closeBookingDetails", true);
    },
    routeToTab: function (tab) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: {
          calendar_date_id: this.$router.currentRoute.params.calendar_date_id,
          tab: tab.route,
        },
        query: {
          ...this.$route.query,
        },
      });
    },
    async onLocalDetailsConfirmedFlagChange(value) {
      this[ActionTypes.BDCdate.UPDATE.SINGLE]({
        item: this.cdate,
        name: "local_details_confirmed_flag",
        value: value ? "1" : "0",
      });

      if (value) {
        this.updateQuestionnaireLockJSON({
          name: "local_details_confirmed_flag",
          value: value ? "1" : "0",
        });
      }

      await wait(3000);
      this.$emit("reloadBookingList");
    },

    onLockQuestion: function ({ name, value }) {
      this[ActionTypes.BDCdate.UPDATE.SINGLE]({
        item: this.cdate,
        name: name,
        value: value,
      });
    },

    // TRAVEL_DETAILS FUNCTIONS

    onDealUpdated: function (payload) {
      const { calendarDateId, value } = payload;

      this[ActionTypes.UPDATE_BOOKING_OFFER_NOTES]({
        calendarDateId,
        value,
      });
    },

    onDocumentDeleted: function (payload) {
      this[ActionTypes.BDDocuments.DELETE.SINGLE]({
        ...payload,
        cdate: this.cdate,
      });
    },
    onDocumentSigned: function (payload) {
      const { signedDocumentType, documentId, subject, signed_documents_id } =
        payload;

      this[ActionTypes.GENERATE_SIGNED_DOCUMENT]({
        signedDocumentType,
        documentId,
        subject,
        calendar_date_id: this.calendar_date_id,
        signed_documents_id,
      });
    },
    onDocumentSendMail: function (payload) {
      const {
        promoterId,
        email,
        displayName,
        emailBody,
        subject,
        documentId,
        contactIdPromoter,
      } = payload;

      this[ActionTypes.SEND_MAIL_ON_SIGNING_CONTRACT]({
        promoterId,
        email,
        displayName,
        emailBody,
        subject,
        documentId,
        contactIdPromoter,
      });
    },

    onEventDetailsInvoiceTextUpdated: function (payload) {
      const { value, invoiceLineId } = payload;

      this[ActionTypes.UPDATE_INVOICE_TEXT]({
        value,
        invoiceLineId,
      });
    },
    onEventDetailsArtistUpdated: function (payload) {
      const { calendarDateArtistId, PRIMARY_KEY, name, value } = payload;

      this[ActionTypes.UPDATE_ARTIST_FIELD]({
        calendarDateArtistId,
        PRIMARY_KEY,
        name,
        value,
      });
    },

    onEventDetailsUpdateDoorOpen: function ({ calendarDateId, value }) {
      this[ActionTypes.UPDATE_DOORS_OPEN]({ calendarDateId, value });
    },
    onEventDetailsUpdateCurfew: function ({ calendarDateId, value }) {
      this[ActionTypes.UPDATE_CURFEW]({ calendarDateId, value });
    },
    onEventDetailsUpdateEventURL: function ({ calendarDateId, value }) {
      this[ActionTypes.UPDATE_EVENT_URL]({ calendarDateId, value });
    },

    onInvoicingUpdateInvoiceText: function (payload) {
      this[ActionTypes.UPDATE_INVOICE_TEXT]({
        ...payload,
        cdate: this.cdate,
      });
    },

    onLineupUpdated: function ({ calendarDateId, value }) {
      this[ActionTypes.UPDATE_LINE_UP]({
        calendarDateId,
        value,
      });
    },

    onTasksCompleted: function ({ calendarDateId, task }) {
      this[ActionTypes.COMPLETE_TASK]({ calendarDateId, task });
    },
    onTasksUndo: function ({ calendarDateId, task }) {
      this[ActionTypes.UNDO_TASK]({ calendarDateId, task });
    },

    //TODO: CENTRALIZED STORE ACTION METHODS ONGOING
    // ALL FOLLOWING METHODSARE FOR NESTED BOOKING DETAILS STRUCTURE
    // PROCEED CONCURRENTLY WITH THE PREVIOUS ACTIONS -
    // AND REDUCE THE TOP PART TO ZERO

    onLoad_travel_from(payload) {
      console.log(payload);

      if (payload.selectedContactTravels?.length == 0) {
        return;
      }

      this[ActionTypes.SET_DEFAULT_TRAVEL_DETAILS]({
        calendar_date_id: this.calendar_date_id,
        from: payload.type,
        travels: JSON.stringify(
          payload.selectedContactTravels?.map((e) => {
            return {
              contact: e.contact_id,
              travel: e.travel_id,
            };
          }) || []
        ),
      });
    },
    onBookingVenueInfoChange(payload) {
      console.log({ payload: payload });
    },

    onTabOptionClicked(value) {
      console.log("onTabOptionClicked", value);
      switch (value) {
        case "open-in-web": {
          // if (this.booking?.promoter) {
          //   } else {
          //     showError(this.$t('choose_promoter_to_open_booking_web_message'));
          // }

          if (this.checkPromoter()) {
            this.onLinkClick();
          }
          break;
        }
        case "copy-link": {
          if (this.booking.link_url?.length > 0) {
            if (this.checkPromoterLocation()) {
              const {
                checksum,
                promoter,
                calendar_date_id,
                questionnaire_url_v2,
              } = this.booking;

              // const URL = `${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/questionnaire?checksum=${checksum}&promoter_id=${promoter?.contact_id}&calendar_date_id=${calendar_date_id}`;

              copyToClipboard(questionnaire_url_v2);
            }
          }
          break;
        }
        case "questionnaire": {
          this.onQuistionnaireClick();
          break;
        }
        case "new_questionnaire_in_web": {
          this.onNewQuistionnaireClick();
          break;
        }
        case "new_questionnaire": {
          this.onBetaQuestionClick();
          break;
        }
        case "questionnaire_lock_status": {
          this.onQuistionnaireLockStatusClick();
          break;
        }
        case "download-ics": {
          this.onDownloadICSClick();
          break;
        }
        case "delete": {
          this.onCalendarDateDeleteClick();
          break;
        }
        default: {
        }
      }
    },

    onDBoxTextAreaBlur(payload) {
      this[ActionTypes.BDCdate.UPDATE.SINGLE]({
        ...payload,
        item: this.booking.cdate,
      });
    },

    onArtistCalendarDateSelected: function (artistCalendarDateId) {
      this.$router.push({
        name: this.$route.name,
        query: {
          calendar_date_artist_id: artistCalendarDateId,
          tab: "performance_details",
        },
      });
    },

    onAITaskAssignDone: function () {
      this[ActionTypes.BDTasks.FETCH.ALL]({
        calendarDateId: this.calendar_date_id,
      });
      this.onTemplateSelectionFetch();
    },

    onAddTaskDone: function () {
      this.addTaskModalCancelled();
      this[ActionTypes.BDTasks.FETCH.ALL]({
        calendarDateId: this.calendar_date_id,
      });
    },
    addTaskModalCancelled: function () {
      this[ActionTypes.BDTasks.FETCH.ALL]({
        calendarDateId: this.calendar_date_id,
      });
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },

    onArtistUpdated: function (payload) {
      if (payload.name === "confirmed_flag") {
        this.updateQuestionnaireLockJSON(payload);
      } else {
        this[ActionTypes.BDArtists.UPDATE.SINGLE](payload);
      }
    },
    onArtistsDelete: function (artist) {
      this[ActionTypes.BDArtists.DELETE.SINGLE](artist);
    },
    addArtistModalDone: function (res) {
      this.addArtistModalCancelled();
      this[ActionTypes.BDArtists.SET.ALL]({
        calendar_date_id: this.calendar_date_id,
        artists: res.data.artists,
      });
    },
    onReloadArtists: async function () {
      const res = await BookingService.loadArtist({ calendarDateId: this.calendar_date_id });
      this[ActionTypes.BDArtists.SET.ALL]({
        calendar_date_id: this.calendar_date_id,
        artists: res.data.artists,
      });
    },

    onBookingCdateUpdated: async function (payload) {
      console.log("onBookingCdateUpdated", payload);
      this[ActionTypes.BDCdate.UPDATE.SINGLE](payload);
      await wait(3000);
      this.$emit("reloadBookingList");
    },

    onNoTravelNeededFlagChange: async function (checked) {
      this.updateQuestionnaireLockJSON({
        name: "no_travel_needed_flag",
        value: checked ? 1 : 0,
      });

      await wait(3000);
      this.$emit("reloadBookingList");
    },

    onBookingTravelDetailsFlagUpdated: async function (payload) {
      await this[ActionTypes.TOGGLE_TDF_FLAG](payload);
      await wait(3000);
      this.$emit("reloadBookingList");
    },
    onCustomChecklistInserted: function (payload) {
      const { calendarDateId, checklistItem } = payload;

      this[ActionTypes.BDCustomChecklist.INSERT.SINGLE]({
        calendarDateId,
        checklistItem,
      });
    },
    onCustomChecklistUpdated: function (payload) {
      const { calendarDateId, oldName, newName } = payload;

      this[ActionTypes.BDCustomChecklist.UPDATE.SINGLE]({
        calendarDateId,
        oldName,
        newName,
      });
    },
    onCustomchecklistChecked: function (payload) {
      console.log({ payload: payload });
      this[ActionTypes.CHECK_CUSTOM_CHECKLIST_ITEM](payload);
    },
    onCustomChecklistUnchecked: function (payload) {
      this[ActionTypes.UNCHECK_CUSTOM_CHECKLIST_ITEM](payload);
    },
    onCustomChecklistDeleted: function (payload) {
      const { calendarDateId, checkListName } = payload;

      this[ActionTypes.BDCustomChecklist.DELETE.SINGLE]({
        calendarDateId,
        checkListName,
      });
    },

    checkPromoter: function () {
      const promoter = this.booking?.promoter;
      if (!promoter) {
        // NotificationService.showNotification({
        //   text: this.$t('choose_promoter_to_open_booking_web_message'),
        //   timeout: 5000,
        //   color: "error",
        // });
        showError(this.$t("choose_promoter_to_open_booking_web_message"));
        return false;
      } else {
        return true;
      }
    },
    checkPromoterLocation: function () {
      const promoter = this.booking?.promoter;
      const promoter2 = this.booking?.promoter2 || {};
      const location = this.booking?.location;
      if (!(promoter && location)) {
        // NotificationService.showNotification({
        //   text: this.$t('need_promoter_location_before_message'),
        //   timeout: 5000,
        //   color: "error",
        // });
        showNotification(this.$t("need_promoter_location_before_message"));
        return false;
      } else {
        return true;
      }
    },

    onQuistionnaireClick: function () {
      if (this.checkPromoterLocation()) {
        //openModalRoute(this, "questionnaire");
        this.$router.push({
          ...this.$route,
          query: {
            modal: "questionnaire",
          },
        });
      }
    },
    onQuistionnaireLockStatusClick: function () {
      openModalRoute(this, "questionnaire_lock_status", {
        newURL: URL,
      });
    },
    onNewQuistionnaireClick: function () {
      if (this.checkPromoterLocation()) {
        const { checksum, promoter, calendar_date_id } = this.booking;

        const URL = `${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/questionnaire?checksum=${checksum}&promoter_id=${promoter?.contact_id}&calendar_date_id=${calendar_date_id}`;

        // openModalRoute(this,"questionnaire",{
        //   newURL:URL
        // })

        window.open(
          `${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/questionnaire?checksum=${checksum}&promoter_id=${promoter?.contact_id}&calendar_date_id=${calendar_date_id}`,
          "_blank"
        );
      }
    },
    onBetaQuestionClick: function () {
      if (this.checkPromoterLocation()) {
        const { checksum, promoter, calendar_date_id, questionnaire_url_v2 } =
          this.booking;

        // const URL = `${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/questionnaire?checksum=${checksum}&promoter_id=${promoter?.contact_id}&calendar_date_id=${calendar_date_id}`;

        openModalRoute(this, "questionnaire", {
          newURL: questionnaire_url_v2,
        });
      }
    },
    onModalCancelled: function () {
      closeModalRoute(this);
    },
    onLinkClick: function () {
      window.open(this.booking.link_url, "_blank");
    },
    onDownloadICSClick: function () {
      window.open(
        `${HttpClient.getBaseUrl()}/booking.pl?section=bookings&action=download_booking_ics&calendar_date_id=${
          this.calendarDateId
        }`,
        "_bank"
      );
    },
    onCalendarDateDeleteClick: function () {
      ConfirmationService.create({
        subject: "Do you really want to delete this Calendar Date?",
        model: true,
        width: 400,
        results: [
          createConfirmResult({
            value: "Yes",
            classes: ["v1"],
          }),
          createConfirmResult({
            value: "No",
          }),
        ],
        completed: (res) => {
          switch (res) {
            case "Yes": {
              overviewService
                .removeCalendarDate({
                  calendar_date_id: this.calendarDateId,
                })
                .then((res) => {
                  console.log("Log: res", res);
                  this.bookingDeleteDone();
                });
              break;
            }
            default: {
            }
          }
        },
      });
    },
    bookingDeleteDone: function () {
      this.$emit("deleted", { calendar_date_id: this.calendar_date_id });
    },

    onInvoicingInvoiceLineDeleted: function (payload) {
      this[ActionTypes.BDInvoiceline.DELETE.SINGLE]({
        ...payload,
        cdate: this.cdate,
      });
    },
    onInvoicingInvoiceLineInsert: function (payload) {
      this[ActionTypes.BDInvoiceline.INSERT.MULTIPLE]({
        ...payload,
        cdate: this.cdate,
      });
    },
    onInvoicingInvoiceLinesSelected: function ({ selectedLines }) {
      this.selectedInvoiceLines = selectedLines;
    },
    onInvoicingUpdated: function (payload) {
      this[ActionTypes.BDInvoiceline.UPDATE.SINGLE]({
        ...payload,
        cdate: this.cdate,
      });
    },
    onCreateInvoiceCreate: async function () {
      if (this.invoiceProjects?.length > 0) {
        return;
      }
      this.invoiceProjectLoading = true;
      BookingService.findBookingInvoiceProjects({
        calendarDateId: this.calendarDateId,
      }).then((res) => {
        this.invoiceProjectLoading = false;
        this.invoiceProjects = res.data.invoice_projects;
      });
    },
    checkForSelectedInvoiceLines: function () {
      if (this.selectedInvoiceLines && this.selectedInvoiceLines.size > 0) {
        return true;
      } else {
        NotificationService.showNotification({
          text: "Please select what should be invoiced",
          timeout: 5000,
          color: "error",
        });
        return false;
      }
    },
    createInvoiceModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },
    doneCreateInvoice: function (data) {
      this.createInvoiceModalCancelled();
      // this[ActionTypes.BDInvoiceline.FETCH.ALL]({
      //   calendar_date_id: this.calendar_date_id,
      // });

      /* Reload both Overview->invoices and Money Details -> invoice_lines */
      this[ActionTypes.FETCH_BOOKING_OVERVIEW_INVOICES]({
        calendarDateId: this.calendar_date_id,
      });

      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: data.invoice_id,
          tab: "overview",
        },
        query: {
          from: encodeRoute(this.$route),
        },
      });
    },
    addInvoiceLineModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },
    // openAddInvoiceModal: function() {
    //   this.$router.push({
    //     ...this.$route,
    //     query: { ...this.$route.query, modal: "add_invoice_line" }
    //   });
    // },
    doneAddInvoiceLine: function (res) {
      this.addInvoiceLineModalCancelled();
      this[ActionTypes.BDInvoiceline.SET.ALL]({
        cdate: this.cdate,
        update: res.data,
      });
    },

    // Documents Methods

    onTemplateSelectionFetch: function () {
      this[ActionTypes.BDDocumentsData.FETCH.ALL]({
        calendar_date_id: this.calendar_date_id,
      });
    },

    // onFileDelete: async function(payload) {
    //   const confirmResult = await confirmDelete("File", payload.item.file_name);
    //   if (confirmResult == "OK") {
    //     this[ActionTypes.BDFiles.DELETE.SINGLE]({
    //       ...payload,
    //       cdate: this.cdate
    //     });
    //   }
    // },

    onSendDocumentAndFilesClick: function (event) {
      if (isCalendarDateIdValid(this.calendarDateId, true)) {
        this.$router.push({
          ...this.$route,
          query: {
            ...this.$route.query,
            modal: "send_doc_files",
            calendar_date_id: this.calendarDateId,
          },
        });
      }
    },

    onArtistCalendarDateModalCancel: function (event) {
      this.$router.push({
        name: this.$route.name,
        query: { calendar_date_artist_id: undefined },
      });
    },
    onArtistCalendarDone: function (payload) {
      this.$router.push({
        name: this.$route.name,
        query: { calendar_date_artist_id: undefined },
      });
      console.log(payload);
      this[ActionTypes.BDArtists.UPDATE.SINGLE](payload);
    },
    addArtistModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },

    onFurtherEventDetailsUpdate: function (payload) {
      this[ActionTypes.BDFields.UPDATE.SINGLE]({
        ...payload,
        cdate: this.cdate,
      });
    },

    onTravelUpdated: function ({ value, name, item }) {
      this[ActionTypes.BDTravels.UPDATE.SINGLE]({
        cdate: this.cdate,
        value,
        name,
        item,
      });
    },

    onTravelDeleted: async function (payload) {
      const { item } = payload;
      console.log("Log: item", item);
      const confirmResult = await confirmDelete(
        "Travel",
        `${item.origin.replace(/<[^>]*>/g, "")}-${item.destination.replace(
          /<[^>]*>/g,
          ""
        )}`
      );
      if (confirmResult == "OK") {
        this[ActionTypes.BDTravels.DELETE.SINGLE]({
          ...payload,
          cdate: this.cdate,
        });
      }
    },
    onTravelInserted: function ({ travel }) {
      this[ActionTypes.BDTravels.INSERT.SINGLE]({
        cdate: this.cdate,
        travel,
      });
    },

    onTravelEdited: function ({ travel }) {
      this[ActionTypes.BDTravels.SET.SINGLE]({
        travel,
        cdate: this.cdate,
      });
    },

    onTDContactRelationsInsert: function (contact) {
      this[ActionTypes.BDContactRelations.INSERT.SINGLE]({
        mode: "relate",
        contact: contact,
        cdate: this.cdate,
      });
    },
    onTDContactRelationInsertContact: function (person) {
      this[ActionTypes.BDContactRelations.INSERT.SINGLE]({
        mode: "insert",
        person,
        cdate: this.cdate,
      });
    },
    onTDContactRelationsDelete: async function (contactRelation) {
      const confirmationResult = await confirmDelete(
        "Contact Relation",
        `${contactRelation.contact_name}`
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.BDContactRelations.DELETE.SINGLE]({
          item: contactRelation,
          cdate: this.cdate,
        });
      }
    },
    onGetContactsClick: function () {
      this[ActionTypes.BDContactRelations.INSERT.ALL]({
        get_contacts_button: true,
        calendar_date_id: this.calendar_date_id,
      });
    },

    onRelationAdded: function ({ payload }) {
      this[ActionTypes.BDLocalDetails.INSERT.SINGLE](payload);
    },
    onRelationDeleted: function (item) {
      this[ActionTypes.BDLocalDetails.DELETE.SINGLE]({
        cdate: this.cdate,
        item,
      });
    },
    onRelationSaved: function ({ payload }) {
      this[ActionTypes.BDLocalDetails.UPDATE.SINGLE]({
        ...payload,
        cdate: this.cdate,
      });
    },
    onRelationsSavePromoter: function ({ fromCalendarDateId }) {
      this[ActionTypes.SAVE_PROMOTER_DEFAULT]({
        fromCalendarDateId,
        cdate: this.cdate,
      });
    },

    onLocalDetailsInfoBlur: function (event) {
      this[ActionTypes.BDCdate.UPDATE.SINGLE]({
        item: this.cdate,
        name: "local_info",
        value: event.target.value,
      });
    },
    updateQuestionnaireLockJSON: function ({ item, name, value }) {
      let lockJson = this.lockJson;

      switch (name) {
        case "confirmed_flag":
          const propertyName = `calendar_date_artists_${item.calendar_date_artist_id}`;
          if (value == "1") {
            lockJson[propertyName] = "lock";
          } else {
            delete lockJson[propertyName];
          }
          break;
        case "local_details_confirmed_flag":
          if (value == "1") {
            this.booking.calendar_date_locals.forEach((row) => {
              lockJson[`local_details_${row.local_detail_id}`] = "lock";
            });
          } else {
            this.booking.calendar_date_locals.forEach((row) => {
              delete lockJson[`local_details_${row.local_detail_id}`];
            });
          }
          break;
        case "no_travel_needed_flag":
          // no_travel_needed value should be 1 or 0
          if (!(value === 1 || value === 0)) {
            return;
          }

          lockJson[`no_travel_needed`] = value;
          break;
        case "toggle_json_item":
          if (lockJson.hasOwnProperty(value)) {
            delete lockJson[value];
          } else {
            lockJson[value] = "lock";
          }
          break;
        case "lock_json":
          this.onLockQuestion({ name, value });
          return;
      }

      this.onLockQuestion({
        name: "lock_json",
        value: JSON.stringify(lockJson),
      });
    },

    async onInvoiceProjectSelected(invoiceProject) {
      this.invoiceProjectLoading = true;
      this.invoiceProjectLoadingText = "Creating Invoice ...";
      const createInvoice = await BookingService.createInvoice({
        calendarDateId: this.calendarDateId,
        invoiceProjectId: invoiceProject["invoice_project_id"],
        invoiceLineIds: `[${Array.from(this.selectedInvoiceLines)
          .map((e) => parseInt(e))
          .join(",")}]`,
      });
      this.invoiceProjectLoadingText = "Invoice Creation Complete";
      this.invoiceProjectLoading = false;
      this.doneCreateInvoice(createInvoice.data);
      this.selectedInvoiceLines = new Set();
    },

    onBalancesSearchClick: function (payload) {
      this.balancesSearchFlag = payload;
    },
    loadTaskList: function (payload) {
      this[ActionTypes.BDTaskList.SET.MULTIPLE](payload);
      // console.log('mdsir: load task', payload);
    },
    addTaskListItem: function (payload) {
      this[ActionTypes.BDTaskList.SET.SINGLE](payload);
      // console.log('mdsir: load task', payload);
    },
    onTaskListItemChanged: function (payload) {
      this[ActionTypes.BDTaskList.UPDATE.SINGLE](payload);
      // console.log('mdsir: load task', payload);
    },
    onTaskListItemDelete: function (payload) {
      this[ActionTypes.BDTaskList.DELETE.SINGLE](payload);
    },
    onClickTaskListMenu: function (menu) {
      // console.log(menu);
      switch (menu) {
        case "load_tasks":
          openModalRoute(this, "task_list_load_tasks");
          break;
        case "add_task":
          openModalRoute(this, "task_list_add_task");
          break;

        default:
          break;
      }
    },
    onClickAIRobot: function () {
      const bodyText = `Hi, I'm your AI assistant, I can currently help you with the following:

      - Tell you the latest fees in any city.
      - Tell you the latest fees for an Artist.
      - Tell you the latest fees in any Venue.
      - Tell you the average fees in any city.
      - Tell you the latest fees of any Promoter.
      - Tell you some flight options between two cities on any date.
      - Set exclusivity around this gig for any radius and length of time.

      And you can ask me anything else and I will hopefully be able to answer you ASAP!`;

      sendMailHref({
        body: bodyText,
        subject: `cd:${this.calendar_date_id}`,
        mails:[`agent_assistant+${clientName}@details.eu`]
      });
    },

    onLoadLocalDetails:async function(payload){
      console.log("PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP",payload)
      await this[ActionTypes.FETCH_LOCAL_DETAILS](payload)
      
    }

    // onQuestionnaireOpenEmailModal() {

    //   //!TODO : change this bad API data redundancy later. This data exist in the state - for Quesionnaire this data is fetched again

    //   // const start_date = this.booking.cdate.start_date;
    //   // const booking_location_name = this.booking.location.booking_location_name;
    //   // const city = this.booking.location.city;
    //   // const country = this.booking.location.country;
    //   // const venue_url = this.booking.location.url1;
    //   // const venue_capacity = this.booking.location.venue_capacity;
    //   // const artists = this.booking.location.booking_location_name;
    //   // const questionnaire_link = this.booking.location.booking_location_name;

    //   const emailDetails = {
    //     type: "questionnaire",
    //   };

    //   openModalRoute(this, "choose_mail_template", {
    //     type: "questionnaire",
    //     calendar_date_id: calendar_date_id,
    //   });
    // },

    // layoutUpdatedEvent: function(change) {
    //   console.log(change);
    // },
    // layoutMountedEvent: function(change) {
    //   console.log(change);
    // }

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-booking-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 223px);
  }
}
// .create-invoice-section {
//   text-align: right;
//   margin-top: 20px;
//   margin-right: -10px;

//   .dt-button {
//     border: var(--btn-border) !important;
//   }
// }

.local-details-confirmed {
  display: flex;
  background: white;
  padding: 10px 5px;
  border-radius: 2px;

  .label {
    flex: 1;
    margin-right: 8px;
  }
  .checkbox {
    /* flex: 1; */
    margin-top: 4px;
  }
}
</style>
